import React from 'react';
import './style.css';

export default function TextHero() {
  return (
    <div className="text-hero">
      <h1 className="title">ISS</h1>
      <h1 className="title notranslate">Tracker</h1>
      <h2 className="subtitle">The International Space Station just a click away.</h2>
    </div>
  );
}
